var Afghanistan = "Afghanistan";
var Albania = "Albanie";
var Algeria = "Algérie";
var Andorra = "Andorre";
var Angola = "Angola";
var Anguilla = "Anguilla";
var Antarctica = "Antarctique";
var Argentina = "Argentine";
var Armenia = "Arménie";
var Aruba = "Aruba";
var Australia = "Australie";
var Austria = "Autriche";
var Azerbaijan = "Azerbaïdjan";
var Bahamas = "Bahamas";
var Bahrain = "Bahreïn";
var Bangladesh = "Bangladesh";
var Barbados = "Barbade";
var Belarus = "Biélorussie";
var Belgium = "Belgique";
var Belize = "Belize";
var Benin = "Bénin";
var Bermuda = "Bermudes";
var Bhutan = "Bhoutan";
var Bolivia = "Bolivie";
var Botswana = "Botswana";
var Brazil = "Brésil";
var Bulgaria = "Bulgarie";
var Burundi = "Burundi";
var Cambodia = "Cambodge";
var Cameroon = "Cameroun";
var Canada = "Canada";
var Chad = "Tchad";
var Chile = "Chili";
var China = "Chine";
var Colombia = "Colombie";
var Comoros = "Comores";
var Congo = "Congo";
var Croatia = "Croatie";
var Cuba = "Cuba";
var Cyprus = "Chypre";
var Denmark = "Danemark";
var Djibouti = "Djibouti";
var Dominica = "Dominique";
var Ecuador = "Équateur";
var Egypt = "Égypte";
var Eritrea = "Érythrée";
var Estonia = "Estonie";
var Ethiopia = "Éthiopie";
var Fiji = "Fidji";
var Finland = "Finlande";
var France = "France";
var Gabon = "Gabon";
var Gambia = "Gambie";
var Georgia = "Géorgie";
var Germany = "Allemagne";
var Ghana = "Ghana";
var Gibraltar = "Gibraltar";
var Greece = "Grèce";
var Greenland = "Groenland";
var Grenada = "Grenade";
var Guadeloupe = "Guadeloupe";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernesey";
var Guinea = "Guinée";
var Guyana = "Guyane";
var Haiti = "Haïti";
var Honduras = "Honduras";
var Hungary = "Hongrie";
var Iceland = "Islande";
var India = "Inde";
var Indonesia = "Indonésie";
var Iraq = "Iraq";
var Ireland = "Irlande";
var Israel = "Israël";
var Italy = "Italie";
var Jamaica = "Jamaïque";
var Japan = "Japon";
var Jersey = "Jersey";
var Jordan = "Jordanie";
var Kazakhstan = "Kazakhstan";
var Kenya = "Kenya";
var Kiribati = "Kiribati";
var Kuwait = "Koweït";
var Kyrgyzstan = "Kirghizistan";
var Latvia = "Lettonie";
var Lebanon = "Liban";
var Lesotho = "Lesotho";
var Liberia = "Libéria";
var Libya = "Jamahiriya arabe libyenne";
var Liechtenstein = "Liechtenstein";
var Lithuania = "Lituanie";
var Luxembourg = "Luxembourg";
var Macao = "Macao";
var Madagascar = "Madagascar";
var Malawi = "Malawi";
var Malaysia = "Malaisie";
var Maldives = "Maldives";
var Mali = "Mali";
var Malta = "Malte";
var Martinique = "Martinique";
var Mauritania = "Mauritanie";
var Mauritius = "Maurice";
var Mayotte = "Mayotte";
var Mexico = "Mexique";
var Monaco = "Monaco";
var Mongolia = "Mongolie";
var Montenegro = "Monténégro";
var Montserrat = "Montserrat";
var Morocco = "Maroc";
var Mozambique = "Mozambique";
var Myanmar = "Myanmar";
var Namibia = "Namibie";
var Nauru = "Nauru";
var Nepal = "Népal";
var Netherlands = "Pays-Bas";
var Nicaragua = "Nicaragua";
var Niger = "Niger";
var Nigeria = "Nigeria";
var Niue = "Niue";
var Norway = "Norvège";
var Oman = "Oman";
var Pakistan = "Pakistan";
var Palau = "Palaos";
var Panama = "Panama";
var Paraguay = "Paraguay";
var Peru = "Pérou";
var Philippines = "Philippines";
var Pitcairn = "Îles Pitcairn";
var Poland = "Pologne";
var Portugal = "Portugal";
var Qatar = "Qatar";
var Romania = "Roumanie";
var Rwanda = "Rwanda";
var Samoa = "Samoa";
var Senegal = "Sénégal";
var Serbia = "Serbie";
var Seychelles = "Seychelles";
var Singapore = "Singapour";
var Slovakia = "Slovaquie";
var Slovenia = "Slovénie";
var Somalia = "Somalie";
var Spain = "Espagne";
var Sudan = "Soudan";
var Suriname = "Suriname";
var Swaziland = "Eswatini";
var Sweden = "Suède";
var Switzerland = "Suisse";
var Taiwan = "Taïwan";
var Tajikistan = "Tadjikistan";
var Thailand = "Thaïlande";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Tunisie";
var Turkey = "Turquie";
var Turkmenistan = "Turkménistan";
var Tuvalu = "Tuvalu";
var Uganda = "Ouganda";
var Ukraine = "Ukraine";
var Uruguay = "Uruguay";
var Uzbekistan = "Ouzbékistan";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Yémen";
var Zambia = "Zambie";
var Zimbabwe = "Zimbabwe";
var countries = {
	"Country or region": "Pays ou région",
	"United States": "États-Unis",
	Afghanistan: Afghanistan,
	"Åland Islands": "Îles Åland",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "Samoa américaines",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antigua-et-Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bosnie-Herzégovine",
	Botswana: Botswana,
	"Bouvet Island": "Île Bouvet",
	Brazil: Brazil,
	"British Indian Ocean Territory": "Territoire britannique de l'océan Indien",
	"Brunei Darussalam": "Brunéi Darussalam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Cap-Vert",
	"Cayman Islands": "Îles Caïmans",
	"Central African Republic": "République centrafricaine",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Île Christmas",
	"Cocos (Keeling) Islands": "Îles Cocos (Keeling)",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Congo (République démocratique du Congo)",
	"Cook Islands": "Îles Cook",
	"Costa Rica": "Costa Rica",
	"Côte d'Ivoire": "Côte d'Ivoire",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "République tchèque",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "République dominicaine",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Guinée équatoriale",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Îles Falkland (Malouines)",
	"Faroe Islands": "Îles Féroé",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Guyane française",
	"French Polynesia": "Polynésie française",
	"French Southern Territories": "Terres australes et antarctiques françaises",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guinée-Bissau",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Île Heard et îles McDonald",
	"Holy See (Vatican City State)": "Saint-Siège (État de la Cité du Vatican)",
	Honduras: Honduras,
	"Hong Kong": "Hong Kong",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "Iran (République islamique d'Iran)",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Île de Man",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Corée (République populaire démocratique de Corée)",
	"Korea, Republic of": "Corée (République de Corée)",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "République démocratique populaire Lao",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Macédoine (ancienne République yougoslave de Macédoine)",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Îles Marshall",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Micronésie (États fédérés de Micronésie)",
	"Moldova, Republic of": "Moldavie (République de Moldavie)",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Antilles néerlandaises",
	"New Caledonia": "Nouvelle-Calédonie",
	"New Zealand": "Nouvelle-Zélande",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Île Norfolk",
	"Northern Mariana Islands": "Îles Mariannes du Nord",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Autorité palestinienne",
	Panama: Panama,
	"Papua New Guinea": "Papouasie-Nouvelle-Guinée",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Porto Rico",
	Qatar: Qatar,
	"Réunion": "La Réunion",
	Romania: Romania,
	"Russian Federation": "Fédération de Russie",
	Rwanda: Rwanda,
	"Saint Helena": "Sainte-Hélène",
	"Saint Kitts and Nevis": "Saint-Christophe-et-Niévès",
	"Saint Lucia": "Sainte-Lucie",
	"Saint Pierre and Miquelon": "Saint-Pierre-et-Miquelon",
	"Saint Vincent and The Grenadines": "Saint-Vincent-et-les-Grenadines",
	Samoa: Samoa,
	"San Marino": "Saint-Marin",
	"Sao Tome and Principe": "Sao Tomé-et-Principe",
	"Saudi Arabia": "Arabie saoudite",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Sierra Leone",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Îles Salomon",
	Somalia: Somalia,
	"South Africa": "Afrique du Sud",
	"South Georgia and The South Sandwich Islands": "Îles Géorgie du Sud et Sandwich du Sud",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard et Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "République arabe syrienne",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Tanzanie (République unie de Tanzanie)",
	Thailand: Thailand,
	"Timor-Leste": "Timor-Leste",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinité-et-Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Îles Turques-et-Caïques",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Émirats arabes unis",
	"United Kingdom": "Royaume-Uni (United Kingdom)",
	"United States Minor Outlying Islands": "Îles mineures éloignées des États-Unis",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Viet Nam",
	"Virgin Islands, British": "Îles Vierges britanniques",
	"Virgin Islands, U.S.": "Îles Vierges américaines",
	"Wallis and Futuna": "Wallis-et-Futuna",
	"Western Sahara": "Sahara occidental",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
